import { createSlice } from '@reduxjs/toolkit';

const initialState = "progression_container small startBottom";

const scrollMobileSlice = createSlice({
    name: "scrollMobile",
    initialState,
    reducers: {
        classAddedMobile(state, action) {         
            return state = action.payload;
        }
    }
});

export const scrollMobileSelector = (state) => state.scrollMobile;

export const { classAddedMobile } = scrollMobileSlice.actions;
export default scrollMobileSlice.reducer;